<template>
  <main class="c-main">
    <findCategory :selectCategories="categories"></findCategory>
    <findProduct></findProduct>
    <div class="card p10">
      <div class="row">
        <CategoryCol
          :languages="languages"
          @update="updateCategoryCol"
        ></CategoryCol>
        <productColumn
          :currentChoosenNode="selectedCategory"
          :units="units"
          :languages="languages"
          @update="updateProductCol"
        ></productColumn>

        <fieldColumn
          :selectedProduct="selectedProduct"
          :units="units"
          :languages="languages"
        ></fieldColumn>
      </div>
    </div>
  </main>
</template>

<script>
import { GET } from "@/shared/api";
import VJstree from "vue-jstree";
import findCategory from "./findCategory";
import findProduct from "./findProduct";
import CategoryCol from "@/views/allLogic/modals/category/categorycolumn";
import productColumn from "@/views/allLogic/modals/product/productColumn";
import fieldColumn from "@/views/allLogic/modals/field/fieldColumn";

export default {
  components: {
    VJstree,
    findCategory,
    findProduct,
    CategoryCol,
    productColumn,
    fieldColumn,
  },
  data() {
    return {
      product: { type: 0 },

      selectedProduct: {
        id: null,
        duplicateCategoryId: null,
      },
      selectedCategory: { id: null },

      categories: [],
      // common data

      units: [],
      languages: [],
    };
  },
  methods: {
    updateProductCol(state) {
      if (typeof state === "object") {
        switch (state.action) {
          case "clicked":
            this.selectedProduct = state.selectedProduct;
            break;
        }
      }
    },
    updateCategoryCol(state) {
      if (typeof state === "object") {
        if (state.action === "products") {
          if (state.mode === "get") {
            this.selectedCategory = state.currentChoosenNode;
            this.selectedProduct = {
              id: null,
              duplicateCategoryId: null,
            };
          } else {
            this.categories = state.categories;
          }
        }
      }
    },

    getUnits() {
      GET([], "/unit", this, false).then((response) => {
        this.units = response;
      });
    },
    getLanguages() {
      GET([], "/language", this, false).then((response) => {
        this.languages = response;
      });
    },
    getProductDetails(id) {
      GET([], `/product/${id}/details`, this, false).then((response) => {
        console.log(response);
      });
    },
  },
  filters: {
    truncate: function (text, length, suffix) {
      return text.substring(0, length) + suffix;
    },
  },
  mounted() {
    this.getUnits();
    this.getLanguages();

    if (localStorage.getItem("check-v1") == null) {
      localStorage.clear();
      this.$router.push({ name: "login" });
    }
  },
};
</script>
